import { Component, Input } from '@angular/core';

@Component({
  selector: 'rl-pending-button',
  templateUrl: './pending-button.component.html',
})
export class PendingButtonComponent {
  constructor() {}

  @Input() isPending: boolean;
  @Input() buttonText: string;
  @Input() buttonPendingText: string;
}
